export default "__VITE_ASSET__BcLT$pJT__"